import Vue from 'vue'
import Router from 'vue-router'
import h5 from '@/components/h5/index'
import pc from '@/components/pc/index'
import h5Leave from '@/components/leaveMsg/h5.vue'
import Leave from '@/components/leaveMsgH5/h5.vue'
import pcLeave from '@/components/leaveMsg/pc.vue'
import LeavePc from '@/components/leaveMsgH5/pc.vue'
import pcOrder from '@/components/order/pc.vue'
import h5Order from '@/components/order/h5.vue'
import pcQuestion from '@/components/question/pc.vue'
import h5Question from '@/components/order/h5.vue'

Vue.use(Router)
let isTrue = false;
if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  // 是移动端打开
  isTrue = true
}
export default new Router({
  mode: 'history',
  base: '/chat_online/',
  routes: [
    {
      path: '/index',
      name: 'chat_online',
      component: isTrue ? h5:pc
    },
    {
      path: '/leaveMsg',
      name: 'leaveMsg',
      component: isTrue ? h5Leave:pcLeave
    },
    {
      path: '/leaveMsgH5',
      name: 'leaveMsgH5',
      component: isTrue ? Leave:LeavePc
    },
    {
      path: '/question',
      name: 'question',
      component: pcQuestion
    },
    {
      path: '/workorder',
      name: 'workorder',
      component: isTrue ? h5Order:pcOrder
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js